//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UiIconButton from './UiIconButton.vue';
import UiProgressLinear from './UiProgressLinear.vue';

export default {
  name: 'UiToolbar',

  components: {
    UiIconButton,
    UiProgressLinear,
  },

  props: {
    type: {
      type: String,
      default: 'default', // 'default', 'colored' or 'clear' - colored is brand primary color
    },
    textColor: {
      type: String,
      default: 'black', // 'black' or 'white'
    },
    title: String,
    brand: String,
    removeBrandDivider: {
      type: Boolean,
      default: false,
    },
    navIcon: {
      type: String,
      default: 'menu',
    },
    removeNavIcon: {
      type: Boolean,
      default: false,
    },
    raised: {
      type: Boolean,
      default: true,
    },
    progressPosition: {
      type: String,
      default: 'bottom', // 'top' or 'bottom'
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return [
        `ui-toolbar--type-${this.type}`,
        `ui-toolbar--text-color-${this.textColor}`,
        `ui-toolbar--progress-position-${this.progressPosition}`,
        { 'is-raised': this.raised },
      ];
    },

    progressColor() {
      return this.textColor === 'black' ? 'primary' : 'white';
    },

    hasBrandDivider() {
      return this.removeBrandDivider ? false : this.brand || this.$slots.brand;
    },
  },

  methods: {
    navIconClick() {
      this.$emit('nav-icon-click');
    },
  },
};

